export function updateObjectInArray<T>(sectionState: Array<T>, index: number, newProperties: Partial<T>): Array<T> {
  return sectionState.map((item, i) => {
    if (i !== index) {
      return item;
    }
    return {
      ...item,
      ...newProperties,
    };
  });
}
